import { render } from "./ProductBoardView.vue?vue&type=template&id=232d3bb0&scoped=true"
import script from "./ProductBoardView.vue?vue&type=script&lang=js"
export * from "./ProductBoardView.vue?vue&type=script&lang=js"

import "./ProductBoardView.vue?vue&type=style&index=0&id=232d3bb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232d3bb0"]])

export default __exports__